export const emojis = [
  {
    id: 1,
    img: require("../assets/1.png"),
    defaultMessage: "Feel a bit upset. Maybe talk next time.",
  },
  {
    id: 2,
    img: require("../assets/2.png"),
    defaultMessage: "Today is a happy day!",
  },
  {
    id: 3,
    img: require("../assets/3.png"),
    defaultMessage: "I'm sick and need some rests."
  },
  {
    id: 4,
    img: require("../assets/4.png"),
    defaultMessage: "Feel tired and going to have a sleep."
  },
  {
    id: 5,
    img: require("../assets/5.png"),
    defaultMessage: "Today is pretty exhausted."
  },
  {
    id: 6,
    img: require("../assets/6.png"),
    defaultMessage: "Just discovered something that's really interesting!"
  },
];
